<template>
  <div ref="observerElement">
    <slot :stop="stop" />
  </div>
</template>

<script setup lang="ts">
import type { MaybeComputedElementRef } from '@vueuse/core'

const {
  threshold = [0, 0.2],
  root,
  rootMargin = '0px 0px 0px 0px',
} = defineProps<{
  threshold: number[] | number
  root?: MaybeComputedElementRef
  rootMargin?: string
}>()

const observerElement = ref(null)

const emit = defineEmits<{
  enter: [value: IntersectionObserverEntry, stop: () => void]
  leave: [value: IntersectionObserverEntry]
}>()

const { stop } = useIntersectionObserver(
  observerElement,
  ([observerEntry]) => {
    if (!observerEntry) {
      return
    }

    const { isIntersecting } = observerEntry
    return isIntersecting
      ? emit('enter', observerEntry, stop)
      : emit('leave', observerEntry)
  },
  { threshold, root, rootMargin },
)

defineOptions({ name: 'IntersectionObserver' })
</script>
